/* eslint-disable max-lines */
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import LinearProgress from '@material-ui/core/LinearProgress';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import FormValidation from '@react-form-fields/material-ui/components/FormValidation';
import FieldSelect from '@react-form-fields/material-ui/components/Select';
import FieldText from '@react-form-fields/material-ui/components/Text';
import { theme } from 'assets/theme';
import { FormComponent, IStateForm } from 'components/Abstract/Form';
import ErrorMessage from 'components/Shared/ErrorMessage';
import Snackbar from 'components/Shared/Snackbar';
import { WithStyles } from 'decorators/withStyles';
import { ICategory } from 'interfaces/category';
import { IEntity } from 'interfaces/entity';
import React from 'react';
import { combineLatest } from 'rxjs';
import RxOp, { IOptions } from 'rxjs-operators';
import categoryService from 'services/category';
import entityService from 'services/entity';

import { IVenture } from '../../../../../interfaces/venture';
import ventureService from '../../../../../services/venture';

const preLabels = ['Aba em:', 'Subaba em:'];

interface ISelectOption {
  id?:number,
  label: string,
  value: string | number,
  level?: number
}

interface IState extends IStateForm<IEntity> {
  loading: boolean;
  error?: null;
  selectorOpened: boolean;
  ventures?: IVenture[];
  entityOptions?: ISelectOption[];
  categoryOptions?: ICategory[];
}

interface IProps {
  opened: boolean;
  entity?: IEntity;
  onComplete: (entity: IEntity) => void;
  onCancel: () => void;
  classes?: any;
}

@WithStyles({
  dialog: {
    width: 1700,
    height: 700,
    maxWidth: '100vw',
  },
  root: {
    maxWidth: '100vw',
  },
  Fragment: {
    marginBottom: 20,
    maxWidth: '100vw',
  },
  img: {
    maxWidth: '100%',
    margin: 'auto',
    display: 'block',
    padding: 5,
    boxShadow: theme.shadows['5']
  },
  cardActions: {
    justifyContent: 'flex-end'
  },
  dialogActions: {
    padding: theme.spacing(2)
  },
  content: {
    width: 1700,
    maxWidth: '100%'
  },
  textField: {
    margin: 8
  },
  heading: {
    marginTop: 30,
    marginBottom: 20
  },
  ImageSelector: {
    marginTop: 30
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 200,
    maxWidth: '100vw',
  },
  Card: {
    marginTop: 30,
    maxWidth: '100vw',
  },
  Paper: {
    width: 600,
    height: 500,
    maxWidth: '100vw',
  },
  moduleOption: {
    backgroundColor: theme.palette.primary.light,
    color: '#FFFFFF',
    '&:hover,&.Mui-selected': {
      color: '#000000'
    },
  }
})
export default class EntityFormDialog extends FormComponent<IProps, IState> {
  constructor(props: {}) {
    super(props);
    this.state = {
      ...this.state,
      loading: true,
      selectorOpened: false,
      ventures: [],
      entityOptions: [] as ISelectOption[],
      categoryOptions: [] as ICategory[],
    };
  }

  get isEdit(): boolean {
    return !!this.state.model.id;
  }

  handleEnter = () => {
    const { entity } = this.props;
    const model: IState['model'] = entity || {
      ventureId: []
    };
    if (!model.parentId) {
      model.parentId = -1;
    }
    if (!model.ventureId) {
      model.ventureId = -1;
    }
    if (!model.ventureId) {
      model.order = null;
    }
    this.setState({ model });
    this.loadData({
      refresh: true,
      persist: false
    });
  };

  handleExit = () => {
    this.resetForm();
  };

  componentDidMount() {
    this.loadData();
  }

  loadData = (options?: Partial<IOptions>) => {
    this.setState({ loading: false, error: null });
    combineLatest([
      ventureService.list({ page: 0, pageSize: 100 }),
      entityService.list({ page: 0, pageSize: Number.MAX_SAFE_INTEGER }),
      categoryService.fecthCategory(null, { refresh: true }),
    ])
      .pipe(RxOp.logError(), RxOp.bindComponent(this))
      .subscribe((value) => {
        const [venturesList, , { data: categoryOptions = [] }] = value;
        this.setState({
          ventures: venturesList.results,
          categoryOptions: categoryOptions || [],
        });
      });

    entityService.list({ page: 0, pageSize: Number.MAX_SAFE_INTEGER }).subscribe(graph => {
      const entities = graph.results.filter(i => !i.parentId);
      const entityOptions = entities.reduce((prev, curr) => {
        if (!prev.map(opt => opt.value).includes(curr.name)) {
          prev.push({ id:curr.id, value: curr.name, label: curr.name, level: curr.level });
        }

        graph.results.filter(e => e.parentId === curr.id).forEach(t => {
          if (!prev.map(opt => opt.value).includes(curr.name + '|' + t.name)) {
            prev.push({
              id: t.id,
              value: curr.name + '|' + t.name,
              label: t.name,
              level: t.level
            });
          }
        });

        return prev;
      }, [] as ISelectOption[]).sort((a, b) => {
        if (a.value < b.value) return -1;
        if (a.value > b.value) return 1;
        return 0;
      });

      entityOptions.unshift({
        value: -1,
        label: 'Módulo',
        level: -1
      });

      this.setState({ entityOptions });

    }, error => console.log(error));
  };

  onSubmit = (isValid: boolean) => {
    const { model: modelState } = this.state;
    const model = { ...modelState };
    const { onComplete } = this.props;
    if (!isValid) return;

    model.parentId =  (model.parentId === -1 ? -1 : typeof model.parentId === 'number' ?
      this.state.entityOptions.find(e => e.id === model.parentId) &&
    this.state.entityOptions.find(e => e.id === model.parentId).value :
      model.parentId as any);

    this.setState({ loading: true });
    if (model.ventureId === -1 || (Array.isArray(model.ventureId) && !model.ventureId.length)) {
      model.ventureId = null;
    }
    entityService.save(model as IEntity).pipe(
      RxOp.logError(),
      RxOp.bindComponent(this)
    ).subscribe(entity => {
      Snackbar.show(Array.isArray(entity) ?
        'Módulos salvos com sucesso!' :
        `${entity.name} foi salvo com sucesso!`
      );
      this.setState({ loading: false });

      onComplete(entity);
    }, err => {
      Snackbar.error(err);
      this.setState({ loading: false });
    });
  };

  render() {
    const { model, loading, error, entityOptions, ventures, categoryOptions } =
      this.state;
    const { opened, classes, onCancel } = this.props;
    return (
      <Dialog
        open={opened}
        disableBackdropClick
        disableEscapeKeyDown
        onEnter={this.handleEnter}
        onExited={this.handleExit}
      >
        {loading && <LinearProgress color="secondary" />}

        <FormValidation onSubmit={this.onSubmit} ref={this.formValidationRef}>
          <DialogTitle>
            {this.isEdit ? 'Editar' : 'Novo'} Módulo/Aba/Subaba
          </DialogTitle>
          <DialogContent className={classes.content}>
            {error && <ErrorMessage error={error} tryAgain={this.loadData} />}

            {!error && (
              <Typography component="div" dir={theme.direction}>
                <div className={classes.field}>
                  <FieldText
                    label="Nome"
                    validation="required|string|max:1000"
                    disabled={loading}
                    value={model.name}
                    onChange={this.updateModel((model, v) => (model.name = v))}
                  />
                  <FieldSelect
                    label="Empreendimento"
                    value={
                      this.isEdit || Array.isArray(model.ventureId)
                        ? model.ventureId
                        : [model.ventureId]
                    }
                    options={(this.isEdit
                      ? [{ label: 'Todos os Empreendimentos', value: -1 }]
                      : []
                    ).concat(
                      ventures.map((venture) => ({
                        label: venture.name,
                        value: venture.id,
                      }))
                    )}
                    validation={this.isEdit ? 'required' : ''}
                    onChange={this.updateModel(
                      (model, v) => (model.ventureId = v)
                    )}
                    multiple={!this.isEdit}
                  />
                  <FieldSelect
                    label="Salvar como"
                    value={
                      model.parentId === -1
                        ? -1
                        : typeof model.parentId === 'number'
                          ? entityOptions.find((e) => e.id === model.parentId) &&
                          entityOptions.find((e) => e.id === model.parentId)
                            .value
                          : model.parentId
                    }
                    validation="required"
                    onChange={this.updateModel(
                      (model, v) => (model.parentId = v)
                    )}
                  >
                    {entityOptions
                      .filter((entity) => entity.value !== model.id)
                      .map((entity) => (
                        <MenuItem
                          key={entity.value}
                          value={entity.value}
                          className={
                            entity.level === 0 ? classes.moduleOption : ''
                          }
                        >
                          {preLabels[entity.level]} {entity.label}
                        </MenuItem>
                      ))}
                  </FieldSelect>
                  {model.level === 0 && this.isEdit && (
                    <FieldText
                      label="Ordem"
                      validation="integer"
                      disabled={loading}
                      value={model.order}
                      onChange={this.updateModel(
                        (model, v) => (model.order = v)
                      )}
                    />
                  )}
                  {model.level === 0 && (
                    <FieldSelect
                      label="Categoria"
                      value={model.categoryId}
                      emptyOption="Nenhum"
                      // validation="required"
                      onChange={this.updateModel(
                        (model, v) => (model.categoryId = v)
                      )}
                    >
                      {categoryOptions.map((category) => (
                        <MenuItem key={`category-${category.id}`} value={category.id}>
                          {category.name}
                        </MenuItem>
                      ))}
                    </FieldSelect>
                  )}
                </div>
              </Typography>
            )}
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            <Button onClick={onCancel}>Cancelar</Button>
            <Button
              color="primary"
              variant={'contained'}
              type="submit"
              disabled={loading || !!error}
            >
              Salvar
            </Button>
          </DialogActions>
        </FormValidation>
      </Dialog>
    );
  }
}